import { useEffect, useState } from 'react';

import NotificationsCount from '@features/enterpriseNotifications/components/NotificationsCount/NotificationsCount';
import NotificationsModal from '@features/enterpriseNotifications/components/NotificationsModal/NotificationsModal';
import { useEnterpriseGetNotifications } from '@features/enterpriseNotifications/hooks/useGetNotifications';
import { getCookie, setCookie } from '@utils/getCookie';
import { Notification } from '@features/enterpriseNotifications/types';

const Notifications = () => {
  const [isNotificationsModalOpen, setIsNotificationsModalOpen] =
    useState(false);
  const [notificationsData, setNotificationsData] = useState<Notification[]>(
    [],
  );
  const { enterpriseNotificationsData, isNotificationsFetched } =
    useEnterpriseGetNotifications({ count: true });
  const isNotificationPopupShown = getCookie('isNotificationPopupShown');

  useEffect(() => {
    if (
      enterpriseNotificationsData?.notifications_count > 0 &&
      !isNotificationPopupShown
    ) {
      const timer = setTimeout(() => {
        setCookie('isNotificationPopupShown', 'true', 1);
        setIsNotificationsModalOpen(true);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [isNotificationsFetched]);

  return (
    <>
      <NotificationsCount
        numberOfNotifications={
          enterpriseNotificationsData?.notifications_count || 0
        }
        handleClick={() => setIsNotificationsModalOpen(true)}
      />
      {isNotificationsModalOpen && (
        <NotificationsModal
          isOpen={isNotificationsModalOpen}
          handleClose={() => {
            setIsNotificationsModalOpen(false);
          }}
          notifications={enterpriseNotificationsData || []}
          setNotificationsData={setNotificationsData}
          notificationsData={notificationsData}
        />
      )}
    </>
  );
};

export default Notifications;
